import React, {useContext} from 'react';
import { LazyImage } from '../../../components/LazyImage'
import cn from 'classnames'
import { displayGranitConfigImage } from '../../../services/image.fct.service'
import { getDesignTypeConfiguration } from '../../../services/utils.service'
import { TranslationContext } from "../../../context/TranslationContext";
import {getStore} from '../../../store';
/**
 * Composant affichant un granite en mode 'monument' 3D
 */
export function GranitePreviewCard({
  monument,
  pictos,
  config,
  granite,
  frameGraniteRef,
  frameMode,
  selected,
  disabledAccessory,
  disabledHeadstone,
  onSelectGranite,
  // price,
  hoverInfo,
  large,
  lazy,
  pattern,
  showConfirm,
  onClickDisableGranite,
  fromFamily=false,
  withAccessories=false,
  color,
  hover,
  price,
  loadingPrice,
  showPrice
}) {
  const options = getStore().getState().configurator.current.options;
  const configuration = getStore().getState().configurator.current.configuration;
  const formatPrice = (price) => {
    return String(price).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  };
  if (!monument) return <div />
  const defMonument = {
    monument: {
      reference: monument.reference,
      graniteMain: granite.reference
    },
    frame: {
      mode: frameMode,
      granite: frameGraniteRef || granite.reference
    }
  }
  const size = large ? 'large' : 'thumbnail'
  const graniteSecondary = granite.gs ? granite.gs : null;
  const frameGranite = (frameGraniteRef === monument.graniteMain) ? granite.reference 
        : (graniteSecondary?.reference && frameGraniteRef === monument.graniteSecondary) 
        ? graniteSecondary.reference
        : frameGraniteRef
  const accessories = withAccessories ? 1 : 0;
  // const frameGranite = frameGraniteRef || granite.reference
  const imageSrc = displayGranitConfigImage(
    config,
    granite.reference,
    false,
    graniteSecondary && graniteSecondary.reference,
    size,
    false,
    accessories,
    0,
    frameGranite,
    0,
    1,
    fromFamily,
    0,
    withAccessories
  )
  const t = useContext(TranslationContext);
  const designType = getDesignTypeConfiguration(config)
  const classType = (designType === 'A' ? 'cardA' : 'cardB')
  const lowResImg = displayGranitConfigImage(
    config,
    granite.reference,
    false,
    graniteSecondary && graniteSecondary.reference,
    'thumbnail',
    false,
    accessories,
    0,
    0,
    0,
    0,
    fromFamily,
    0,
    withAccessories
  )

  const hasFrameStock = options.stocksFrames.some(
    st => st.gm === (frameGranite || monument.graniteMain)
  );

  const hasGraniteStock = options.stocks.some(
    stock =>
      stock.gm === granite.reference &&
      (
        monument.graniteSecondary && monument.graniteSecondary !== ""
          ? stock.gs === (
            graniteSecondary
            ? graniteSecondary.reference
            : monument.graniteSecondary
          )
          : true
      )
  );

  const inStock = (!(configuration.veneer && configuration.veneer.weight && configuration.veneer.weight !== "0" && configuration.veneer.layout))
                ? hasGraniteStock && (!frameMode || hasFrameStock) : false;
  
  const disabled = disabledAccessory || disabledHeadstone
  const hoverData = hoverInfo && hoverInfo(granite)
  let disabledMessage
  if (disabled) {
    if (disabledAccessory && disabledHeadstone) {
      disabledMessage = (
        <p>Ce granit n'est pas compatible avec les pièces sélectionnées.</p>
      )
    } else if (disabledAccessory) {
      disabledMessage = (
        <p>
          Ce granit n'est pas compatible avec certains des accessoires présents.
          <br />
          <br />
          Le choix de ce granit entraînera la suppression de ces accessoires.
        </p>
      )
    } else {
      disabledMessage = (
        <p>
          Ce granit n'est pas compatible avec la stèle sélectionnée.
          <br />
          <br />
          Modifiez votre stèle si vous souhaitez utiliser ce granit.
        </p>
      )
    }
  }
  return (
    <div
      className={cn([
        'GraniteCard',
        'GranitePreviewCard',
        { selected, disabled, disabledAccessory, showConfirm },
        classType
      ])}
      style={{"--f-main-color": color}}
    >
      <div
        className={cn(['GraniteCardContent'])}
        onClick={() => {
          if (!disabled) {
            onSelectGranite(granite)
          } else {
            onClickDisableGranite(granite)
          }
        }}
      >
        {lazy ? (
          <LazyImage
            src={imageSrc}
            lowResImage={lowResImg}
            hoverInfo={hoverData}
            customStyle={true}
            throttle={true}
          />
        ) : (
          <LazyImage src={imageSrc} lazy={false} hoverInfo={hoverData} fromFamily={fromFamily} customStyle={true} throttle={true} />
        )}
        {disabled && <div className='DisabledMessage'>{disabledMessage}</div>}
        <div className='Infos'>
          <h3 className='Name'>{graniteSecondary && graniteSecondary.reference !== granite.reference && !fromFamily ? `${granite.name} ${t("catalog_product_granits_and")}  ${t(`config3d_granit_${graniteSecondary.reference}`)}`: granite.name}
            {inStock && 
              <span className="stock-icon stock-theme-icon" role="img" aria-label="Stock"></span>
          }
          </h3>
          {/* {price && <div className='Price'>A partir de {granite.price}€</div>} */}
          <div class="sellingprice">
            {showPrice && <>
              {loadingPrice ? (
                <span className="priceLoader" />
              ) : price && price !== "" && !Number.isNaN(Number(price)) ? (
                <>
                  <div className="price-icon">
                    <span className="arrow-up-icon icon-medium text-dark-icon" />
                    <span className="price-icon-text">PV</span>
                  </div>

                  <div className="price-text">
                    <span>{formatPrice(price)}</span>€
                  </div>
                </>
              ) : (
                <div className="price-text">
                  <span>Prix non disponible</span>
                </div>
              )}
          </>}
          </div>
        </div>
        <div className='pictos'>
          <ul>
            {pictos &&
              pictos.map((element, i) => {
                return (
                  <li key={i}>
                    <img src={element.picture} />
                  </li>
                )
              })}
          </ul>
        </div>
      </div>
    </div>
  )
}
